/** Decode HTML entities in text using the browser's built-in HTML parser. */
export function decodeHtmlEntities(text: string): string {
  const doc = new DOMParser().parseFromString(text, 'text/html')
  return doc.body.textContent || text
}
